import { Icon } from "../../../components/BaseComponents/Icon";

export const CouponBackgroundIcon = (props) => (
	<Icon viewBox="0 0 78 78" fill="none" {...props}>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="4"
			d="m34 44 32-32m-22.4 3.2a6.4 6.4 0 1 1-12.8 0 6.4 6.4 0 0 1 12.8 0Zm25.6 25.6a6.4 6.4 0 1 1-12.8 0 6.4 6.4 0 0 1 12.8 0Zm16 3.2L98 28 85.2 12V-7.2H66L50-20 34-7.2H14.8V12L2 28l12.8 16v19.2H34L50 76l16-12.8h19.2V44Z"
		/>
	</Icon>
);
